<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [stroke]="chartOptions.stroke!"
        [markers]="chartOptions.markers!"
        [fill]="chartOptions.fill!"
        [legend]="chartOptions.legend!"
        [title]="chartOptions.title!"
    ></apx-chart>
</div>